
export const MAKE_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-5 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            left: "flex items-center gap-4",
            iconBox: "w-12 h-12 rounded-2xl bg-violet-100 flex items-center justify-center",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-0.5",
        },
        actionButton: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95",
    },
    stats: {
        grid: "grid grid-cols-2 md:grid-cols-3 gap-3",
        card: "bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3 hover:shadow-sm transition-shadow",
        iconBox: "w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0",
        value: "text-xl font-bold text-gray-900",
        label: "text-xs text-gray-500",
    },
    table: {
        container: "bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden",
        header: "bg-gray-50/50 text-xs font-semibold text-gray-500 uppercase tracking-wider",
        row: "hover:bg-gray-50/50 transition-colors",
        cellName: "font-medium text-gray-900",
        cellUrl: "text-gray-500 font-mono text-xs truncate max-w-[300px]",
        actions: "flex items-center gap-1",
        actionButton: "p-2 rounded-lg transition-all",
        editButton: "text-gray-400 hover:bg-violet-50 hover:text-violet-600",
        deleteButton: "text-gray-400 hover:bg-red-50 hover:text-red-500",
    },
    emptyState: {
        container: "flex flex-col items-center justify-center py-16 text-center",
        iconBox: "w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-4",
        title: "text-lg font-medium text-gray-900 mb-1",
        subtitle: "text-sm text-gray-500",
    },
    modal: {
        content: "sm:max-w-[500px] p-0 overflow-hidden border-none rounded-xl shadow-2xl",
        header: {
            container: "p-6 pb-3 border-b border-gray-100 bg-white",
            iconRow: "flex items-center gap-3 mb-1",
            iconBox: "w-9 h-9 rounded-xl flex items-center justify-center",
            iconCreate: "bg-violet-100 text-violet-600",
            iconEdit: "bg-blue-100 text-blue-600",
            title: "text-lg font-bold text-gray-900",
            subtitle: "text-sm text-gray-500 mt-0.5",
        },
        body: "p-6 flex flex-col gap-5 bg-[#F9FAFB]",
        label: "text-xs font-semibold text-gray-500 uppercase tracking-wider",
        input: "bg-white border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200",
        footer: "p-4 bg-white flex justify-end gap-2 border-t border-gray-100",
    },
};
